<div class="empty">
  <h3>
    Desculpe, não conseguimos encontrar a página ou você não tem permissão para
    acessá-la.
  </h3>
  <p>Verifique o endereço ou entre em contato com o suporte para mais ajuda.</p>

  <img src="assets/img/empty-pana.png" alt="empty-pana" width="400px" />
</div>
